import { z } from 'zod';

import { HumanTaskPayloadSchema } from './humanTask.js';

export const HumanTaskExecuteReturnTypeSchema = z.object({
  expiresAt: z.date(),
});
export type HumanTaskExecuteReturnType = z.infer<typeof HumanTaskExecuteReturnTypeSchema>;

export const HumanTaskActivityReturnTypeSchema =
  HumanTaskPayloadSchema.shape.subtaskValues.nullish();
export type HumanTaskActivityReturnType = z.infer<typeof HumanTaskActivityReturnTypeSchema>;

export const HumanTaskBaseMetadataSchema = z.object({
  humanTaskId: z.string().optional(),
});
export type HumanTaskBaseMetadata = z.infer<typeof HumanTaskBaseMetadataSchema>;

export const HumanTaskExecuteMetadataSchema = HumanTaskBaseMetadataSchema.extend({
  waitTimeInMilliseconds: z.number().optional(),
  expiresAt: z.date().optional(),
});
export type HumanTaskExecuteMetadata = z.infer<typeof HumanTaskExecuteMetadataSchema>;

export const HumanTaskActivityMetadataSchema = HumanTaskBaseMetadataSchema.and(
  HumanTaskPayloadSchema.shape.metadata
);
export type HumanTaskActivityMetadata = z.infer<typeof HumanTaskActivityMetadataSchema>;
